
export default {
    props: ['title', 'message', 'content'],
}
